import { render, staticRenderFns } from "./Privacidad.vue?vue&type=template&id=0342d6ba&"
import script from "./Privacidad.vue?vue&type=script&lang=js&"
export * from "./Privacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports